<template>
  <div class="chartContainer">
    <h2 v-if="heading">{{ heading }}</h2>

    <img
        :src="base64Image"
        :style="imageStyle"
        alt=""
        class="chart-image"
    >

    <div v-show="false"
         class="chart"
    >
      <div>
        <component
            :is="chartType"
            v-if="chartData"
            :chartData="chartData"
            :height="settings.style.height * 4"
            :settings="settings"
            :width="settings.style.width * 4"
            @generateChartImage="updateChartImage"
        >
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import ChartHistory
  from './ChartHistory.vue'
import ChartHorizontalBar
  from './ChartHorizontalBar.vue'
import ChartVerticalBar
  from './ChartVerticalBar.vue'
import ChartReport
  from './ChartReport.vue'
import ChartPortfolioBar
  from '../portfolio/charts/ChartPortfolioBar.vue'
import ChartDoughnut
  from '../portfolio/charts/ChartDoughnut.vue'
import ChartPortfolioHistory
  from '../portfolio/charts/ChartPortfolioHistory.vue'

export default {
  name: 'chart-container',
  props: [
    'chartData',
    'chartType',
    'settings',
    'heading',
  ],
  data() {
    return {
      base64Image: null,
    }
  },
  methods: {
    updateChartImage(base64String) {
      this.base64Image = base64String
    },
  },
  computed: {
    imageStyle() {
      return {
        height: this.settings.style.height + 'px',
        width: this.settings.style.width + 'px',
        display: 'block',
      }
    },
  },
  components: {
    ChartHistory,
    ChartHorizontalBar,
    ChartVerticalBar,
    ChartReport,
    ChartPortfolioBar,
    ChartPortfolioHistory,
    ChartDoughnut,
  },
}
</script>



// WEBPACK FOOTER //
// ChartContainer.vue?3b312822